import { render } from "./loading.vue?vue&type=template&id=d5354f36&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=d5354f36&scoped=true&lang=css"

import exportComponent from "/Users/user/crud-projects/crederi-all/crederi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5354f36"]])

export default __exports__